import React from 'react';
import { LinkedInArticleComponent as LinkedInArticleComponentType } from '../types';

interface LinkedInArticleComponentProps {
  articleComponent: LinkedInArticleComponentType;
}

export const LinkedInArticleComponent: React.FC<LinkedInArticleComponentProps> = ({ articleComponent }) => {
  const handleClick = () => {
    window.open(articleComponent.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div 
      className="bg-gray-100 rounded-lg border border-gray-200 overflow-hidden cursor-pointer hover:shadow-lg transition-shadow duration-200 my-3"
      onClick={handleClick}
    >
      <div className="flex">
        {/* Left side - Thumbnail Image */}
        {articleComponent.thumbnail && articleComponent.thumbnail.url && <div className="w-[40%] flex-shrink-0 flex items-center justify-center">
          <div className="relative w-full h-full flex items-center justify-center">
            <img
              src={articleComponent.thumbnail.url}
              alt={articleComponent.title}
              className="w-full h-full max-h-[150px] object-cover object-center"
              style={{ maxHeight: '150px', objectFit: 'cover', objectPosition: 'center' }}
              onError={(e) => {
                e.currentTarget.src = "/assets/placeholder.jpg";
              }}
            />
          </div>
        </div>}
        
        {/* Right side - Text Content */}
        <div className="w-[60%] p-4 flex flex-col justify-center">
          <h3 className="text-black font-semibold text-base leading-tight mb-1 line-clamp-2">
            {articleComponent.title}
          </h3>
          <p className="text-gray-500 text-sm">
            {articleComponent.subtitle}
          </p>
        </div>
      </div>
    </div>
  );
};
